import React from 'react';
import { Section, Collection } from 'react-aria-components';

function ListItemSection(props) {
  return /*#__PURE__*/React.createElement(Section, {
    className: "csg-tw-list-item-section after:block after:h-[5px] after:content-[''] first:mt-[-5px]"
  }, /*#__PURE__*/React.createElement(Collection, {
    items: props.items
  }, props.children));
}

export { ListItemSection as default };
//# sourceMappingURL=list-item-section.esm.js.map
